import React from "react";
import TransactionListASAP from "./TransactionListASAP"

export default class CashSales extends React.Component {

    async componentDidMount() {
        document.body.style.backgroundColor = "#e6e6fa";

        localStorage.setItem('TransactionType', JSON.stringify(5));
    }

    render() {
        return (
            <div>
                <TransactionListASAP type={5} history={this.props.history} delivery={false}></TransactionListASAP>
            </div>
        );
    }
}